import { useTranslation } from 'react-i18next';
import { MenuDayTableMealSection } from './MenuDayTableMealSection';

export const MenuDayTable = ({ menu, onRemove }) => {
    const { t } = useTranslation('recipe');

    return (
        <table>
            <thead>
            <tr>
                <th className={'th'} rowSpan={2}>{t('title')}</th>
                <th className={'td'} colSpan={2}>{t('allProteins')}</th>
                <th className={'td'} colSpan={2}>{t('allFat')}</th>
                <th className={'td'} colSpan={2}>{t('allCarbohydrates')}</th>
                <th className={'td'} colSpan={2}>{t('allEnergyValueKcal')}</th>
                <th className={'td'} />
            </tr>
            <tr>
                <td className={'td'}>{t('common:cradle')}</td>
                <td className={'td'}>{t('common:kindergarten')}</td>
                <td className={'td'}>{t('common:cradle')}</td>
                <td className={'td'}>{t('common:kindergarten')}</td>
                <td className={'td'}>{t('common:cradle')}</td>
                <td className={'td'}>{t('common:kindergarten')}</td>
                <td className={'td'}>{t('common:cradle')}</td>
                <td className={'td'}>{t('common:kindergarten')}</td>
                <td className={'td'} />
            </tr>
            </thead>
            <tbody>
            <MenuDayTableMealSection mealName={t('monthMenu:BREAKFAST')}
                                     recipes={menu.recipes}
                                     mealId={1}
                                     mealColor={'#e5a7a7'}
                                     onRemove={onRemove}>
            </MenuDayTableMealSection>
            <MenuDayTableMealSection mealName={t('monthMenu:LUNCH')}
                                     recipes={menu.recipes}
                                     mealId={2}
                                     mealColor={'#e5d3a7'}
                                     onRemove={onRemove}>
            </MenuDayTableMealSection>
            <MenuDayTableMealSection mealName={t('monthMenu:DINNER')}
                                     recipes={menu.recipes}
                                     mealId={3}
                                     mealColor={'#d3e5a7'}
                                     onRemove={onRemove}>
            </MenuDayTableMealSection>
            <MenuDayTableMealSection mealName={t('monthMenu:SNACK')}
                                     recipes={menu.recipes}
                                     mealId={4}
                                     mealColor={'#93a171'}
                                     onRemove={onRemove}>
            </MenuDayTableMealSection>
            <tr>
                <th className={'td'}>{t('monthMenu:sum')}</th>
                <th className={'td'}>{menu.carbohydratesCradle}</th>
                <th className={'td'}>{menu.carbohydrates}</th>
                <th className={'td'}>{menu.proteinsCradle}</th>
                <th className={'td'}>{menu.proteins}</th>
                <th className={'td'}>{menu.fatCradle}</th>
                <th className={'td'}>{menu.fat}</th>
                <th className={'td'}>{menu.energyValueKcalCradle}</th>
                <th className={'td'}>{menu.energyValueKcal}</th>
            </tr>
            </tbody>
        </table>
    );
};